module.exports = __webpack_public_path__ + "static/media/kasko awaz man paryo.fc5ba9bf.ogg";